import { Button, message, Modal, Spin, Tabs, UploadFile } from "antd";
import FileUploads from "app/components/FileUploads";
import { useHandleSubmitApi } from "hook";
import { EDestinationMediaUpload, IMediaOutputModel } from "interfaces/media";
import { useEffect, useState } from "react";
import { MediaServices } from "services/media";
import { FormDataUtil } from "utils/form";
import MediaUploadTable from "./MediaUploadTable/MediaUploadTable.presenter";

export interface IMediaUploadModalProps {
  visible: boolean;
  isHiddenChooseMedia?: boolean;
  activeKey: "1" | "2";
  isMultipleSelect?: boolean;

  onClose?: () => void;
  onChangeActiveKey?: (activeKey: string) => void;
  onUploadCompleted?: () => void;
  onChooseCompleted?: (item: IMediaOutputModel[]) => void;
}

export default function MediaUploadModal(props: IMediaUploadModalProps) {
  // Mọi file đều lưu trên cloud (Google Drive), không còn lưu trên server
  const destination = EDestinationMediaUpload.Cloud;
  const [medias, setMedias] = useState<IMediaOutputModel[]>([]);
  const [key, setKey] = useState<"1" | "2">(props.activeKey);

  useEffect(() => {
    props.activeKey && setKey(props.activeKey);
  }, [props.activeKey]);

  const [createMediaService, loadingCreate] = useHandleSubmitApi(
    async (files: UploadFile<any>[]) => {
      const formData = FormDataUtil.convertJsonToFormData(
        { files, destination },
        {
          handelObjectInArr: (input) => {
            const temp = FormDataUtil.transformObjectFormData({
              mainKey: input.mainKey,
              data: input.data,
              mainIdx: input.mainIdx,
              customKeyForm: ({ mainKey, key, mainIdx }) => {
                return `${mainKey}[${mainIdx}][${key}]`;
              },
            });

            return temp;
          },
        }
      );
      const dataRes = await MediaServices.createMedia(formData);
      if (dataRes) {
        message.success("Cập nhật thành công!");
        props.onUploadCompleted && props.onUploadCompleted();
      }
    }
    // () => message.error("Có lỗi xảy ra, vui lòng thử lại sau!")
  );

  const renderUpload = () => {
    return (
      <>
        <Spin spinning={loadingCreate}>
          <FileUploads
            onChange={async (value) => {
              await createMediaService(value as UploadFile<any>[]);
            }}
            showUploadList={false}
            // isNonFileList
          />
        </Spin>
      </>
    );
  };

  const renderList = () => {
    return <MediaUploadTable isMultipleSelect={props.isMultipleSelect} medias={medias} onChooseItem={setMedias} />;
  };

  const handleClose = () => {
    !loadingCreate && props.onClose && props.onClose();
  };

  const handleSubmit = () => {
    if (!medias) return;
    setMedias([]);
    props.onChooseCompleted && props.onChooseCompleted(medias);
  };

  const renderFooter = () => {
    if (props.isHiddenChooseMedia || key === "1") return false;
    return (
      <div className="media-list-information__footer">
        <div className="media-list-information__footer-left"></div>
        <div className="media-list-information__footer-right">
          <Button
            disabled={!medias?.length}
            size="large"
            className=""
            style={{ width: 200 }}
            color="primary"
            variant="solid"
            onClick={handleSubmit}
          >
            Thêm vào thư viện
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal
        title="Tải ảnh"
        open={props.visible}
        footer={renderFooter}
        onCancel={handleClose}
        onClose={handleClose}
        // loading={loadingCreate}
        width={"100%"}
        style={{ top: 10 }}
        rootClassName="media-upload-modal"
      >
        <Tabs
          defaultActiveKey={key}
          activeKey={key}
          onChange={(activeKey: any) => {
            setKey(activeKey);
            props.onChangeActiveKey && props.onChangeActiveKey(activeKey);
          }}
          items={[
            {
              label: "Tải lên tệp mới",
              key: "1",
              children: renderUpload(),
            },
            {
              label: "Chọn từ thư viên Media",
              key: "2",
              children: key === "2" && renderList(),
              disabled: !!props.isHiddenChooseMedia,
            },
          ]}
        />
      </Modal>
    </>
  );
}
